var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-contacts"},[_c('p',{staticClass:"card-contacts__text card-contacts__text--small"},[_c('b',[_vm._v("ИНН: ")]),_vm._v(_vm._s(_vm.inn)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }